module.exports = __webpack_public_path__ + "media/1x1/be-f1e78c8b.svg";